import { render } from "./TransfeeraBankAccountSelectionContainer.vue?vue&type=template&id=6f486c08"
import script from "./TransfeeraBankAccountSelectionContainer.vue?vue&type=script&lang=js"
export * from "./TransfeeraBankAccountSelectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__